{
  "title": "New transfer",
  "description": "Choose the transfer direction, then send it to the customer to fill in and sign.",
  "branch": "Branch: {{branch}}",
  "fields": {
    "direction": "Transfer direction",
    "box": "Box",
    "boxOption": "{{name}} - balance {{balance}}",
    "bankAccount": "Bank account",
    "amount": "Transfer amount",
    "amountHint": "In Jordanian dinars, up to five decimal places",
    "reference": "Transfer reference",
    "senderIsReceiver": "Sender is the receiver",
    "notes": "Notes",
    "target": "Customer device",
    "commissionMode": "Commission method",
    "customerNotPresent": "Customer not present",
    "customerNotPresentHint": "Nothing is sent to the tablet; the transaction is saved without the customer's data and signature."
  },
  "direction": {
    "BANK_TO_CASH": "Bank to cash",
    "BANK_TO_CASHHint": "The amount arrives in the bank account and the customer collects the net in cash from the box.",
    "CASH_TO_BANK": "Cash to bank",
    "CASH_TO_BANKHint": "The customer hands over the cash and the amount goes to the receiver's bank account."
  },
  "commissionMode": {
    "DEDUCTED": "Deducted from the amount",
    "DEDUCTEDHint": "The customer hands over the amount; the amount minus the commission is transferred.",
    "ADDED": "Added on top of the amount",
    "ADDEDHint": "The customer hands over the amount plus the commission; the full amount is transferred."
  },
  "validation": {
    "boxRequired": "Choose the box",
    "bankAccountRequired": "Choose the bank account",
    "amountInvalid": "Enter a valid amount",
    "amountDecimals": "At most five decimal places are allowed.",
    "amountPositive": "The amount must be greater than zero",
    "targetRequired": "Choose a tablet or this device"
  },
  "card": {
    "title": "Transfer details",
    "tier": "Tier",
    "noLimit": "No limit",
    "commission": "Commission",
    "commissionMode": "Commission method",
    "amountCashToBank": "Amount received from the customer",
    "net": "Net cash",
    "netCashToBank": "Amount transferred",
    "boxBalance": "Box Balance",
    "accountBalance": "Bank account balance",
    "enterAmount": "Enter the transfer amount to see the commission and net cash",
    "noTier": "No tier for this amount",
    "commissionNotBelow": "The commission is equal to or above the transfer amount",
    "insufficientBox": "Insufficient box balance",
    "insufficientAccount": "Insufficient bank account balance",
    "calculating": "Calculating..."
  },
  "duplicate": {
    "warning": "Transfer reference used in another transfer",
    "link": "Transfer {{number}}",
    "draftLink": "A draft transfer",
    "note": "You may continue; the warning is stored with the transfer."
  },
  "target": {
    "thisDevice": "This device",
    "online": "Online",
    "offline": "Offline",
    "noTablets": "No tablets in this branch",
    "busy": "Busy",
    "notConfigured": "The tablet service is not connected to this system",
    "unavailable": "The tablet service could not be reached"
  },
  "actions": {
    "send": "Send to tablet",
    "sending": "Sending...",
    "resend": "Resend to tablet",
    "discard": "Discard request",
    "post": "Post transfer",
    "newTransfer": "New transfer",
    "printReceipt": "Print receipt",
    "viewDetails": "View Details",
    "editParties": "Edit party details",
    "saveDraft": "Save as draft"
  },
  "capture": {
    "title": "Customer details",
    "notSent": "The request has not been sent to the customer's device yet",
    "waitingTablet": "Waiting for the customer on {{tablet}}",
    "waitingThisDevice": "Waiting for the customer on this device",
    "tabletOffline": "The tablet is offline",
    "tabletOnline": "The tablet is online",
    "submittedAt": "The customer completed the details at {{time}}",
    "signatureVoid": "The details changed after signing. Send them to the customer again.",
    "cancelled": "This request was cancelled on the customer's device",
    "expired": "The request ended before the customer finished. Send it to the customer again.",
    "failed": {
      "SIGNATURE_INVALID": "Could not save the signature. Nothing was saved; send it to the customer again.",
      "DATA_INVALID": "The customer's details are incomplete or not valid. Nothing was saved; send it to the customer again.",
      "NOT_COLLECTED": "The customer's details could not be collected from the tablet service. Send it to the customer again."
    }
  },
  "review": {
    "receiver": "Receiver",
    "receiverSelf": "Sender and receiver",
    "sender": "Sender",
    "fullName": "Full Name",
    "phone": "Phone",
    "document": "Document",
    "documentTypes": {
      "NATIONAL_ID": "National ID",
      "PASSPORT": "Passport"
    },
    "documentNumber": "Document Number",
    "documentCountry": "Issuing Country",
    "language": "Customer language",
    "languages": {
      "ar": "العربية",
      "en": "English"
    },
    "signature": "Signature",
    "signatureLoading": "Loading the signature",
    "signatureFailed": "The signature could not be loaded",
    "customers": "In Customers",
    "matchFound": "{{name}} - level {{level}}",
    "matchFoundNoName": "Registered without a name - level {{level}}",
    "matchNotFound": "Not registered",
    "matchUnavailable": "Customers could not be reached"
  },
  "blockers": {
    "title": "The transfer cannot be posted yet",
    "NO_TIER": "No tier for this amount",
    "COMMISSION_NOT_BELOW_AMOUNT": "The commission is equal to or above the transfer amount",
    "INSUFFICIENT_BOX_BALANCE": "Insufficient box balance",
    "INSUFFICIENT_BANK_BALANCE": "Insufficient bank account balance",
    "BOX_INACTIVE": "The box is inactive",
    "BANK_ACCOUNT_INACTIVE": "The bank account is inactive",
    "CAPTURE_MISSING": "Waiting for the customer's details and signature",
    "SIGNATURE_VOID": "The details changed after signing",
    "unsaved": "The transfer details changed. Send them to the customer again."
  },
  "post": {
    "title": "Post transfer",
    "effect": "Receive {{amount}} in account {{account}} and pay {{net}} in cash from {{box}}, commission {{commission}}, receiver {{receiver}}",
    "effectCashToBank": "Receive {{amount}} in cash into {{box}} and transfer {{net}} from account {{account}}, commission {{commission}} ({{mode}}), sender {{sender}}, receiver {{receiver}}",
    "checkBank": "Make sure the amount reached the bank account and count the cash before confirming.",
    "checkCash": "Count the cash and make sure the amount transferred reaches the receiver's account before confirming.",
    "confirm": "Confirm",
    "posting": "Posting..."
  },
  "result": {
    "title": "The transfer was posted",
    "number": "Transfer number",
    "net": "Net cash paid",
    "amountCashToBank": "Amount received from the customer",
    "netCashToBank": "Amount transferred",
    "message": "WhatsApp message",
    "messageNone": "No message",
    "sync": "Customers",
    "syncPending": "Awaiting synchronisation",
    "syncDone": "Synchronised",
    "messageStatus": {
      "PENDING": "Awaiting sending",
      "SENT": "Sent",
      "DELIVERED": "Delivered",
      "FAILED": "Sending failed"
    }
  },
  "discard": {
    "title": "Discard the request?",
    "description": "The draft transfer becomes cancelled without any effect on balances.",
    "keep": "Keep the transfer",
    "done": "The request was discarded"
  },
  "parties": {
    "title": "Edit party details",
    "description": "Any change voids the signature and the form must be sent to the customer again.",
    "saved": "The party details were updated",
    "invalidValue": "The value is not valid"
  },
  "toasts": {
    "sent": "Sent to the customer's device",
    "resent": "Sent again",
    "saved": "Saved"
  },
  "notDraft": {
    "title": "This transfer is no longer a draft",
    "body": "Another employee approved or cancelled it. Open its details to see its state.",
    "open": "View details"
  }
}
